import { __assign } from "tslib";
import * as React from 'react';
function IconFunnelSizeS(props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 16 16" }, props),
        React.createElement("path", { d: "M14 2H2v1.276a2 2 0 00.464 1.28l4.072 4.888A2 2 0 017 10.724V15l2-1v-3.276a2 2 0 01.464-1.28l4.072-4.888A2 2 0 0014 3.276V2z" })));
}
export default IconFunnelSizeS;
